import { IFilter } from "@saleor/components/Filter";
import { FilterOpts, MinMax } from "@saleor/types";
import {
  createDateField,
  createOptionsField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum ProductDetailsBiFilterKeys {
  updateDate = "updateDate",
  productStatus = "productStatus"
}

export enum ProductDetailStatus {
  DRAFT = "Draft",
  READY = "Ready",
  UNLISTED = "Unlisted"
}

export interface ProductDetailsBiFilterOpts {
  updateDate: FilterOpts<MinMax>;
  productStatus: FilterOpts<string[]>;
}

const messages = defineMessages({
  draft: {
    defaultMessage: "Draft",
    description: "draft status"
  },
  productStatus: {
    defaultMessage: "Product Status",
    description: "product status"
  },
  ready: {
    defaultMessage: "Ready",
    description: "ready status"
  },
  unlisted: {
    defaultMessage: "Unlisted",
    description: "unlisted status"
  },
  updateDate: {
    defaultMessage: "Updated Date",
    description: "product update "
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: ProductDetailsBiFilterOpts
): IFilter<ProductDetailsBiFilterKeys> {
  return [
    {
      ...createOptionsField(
        ProductDetailsBiFilterKeys.productStatus,
        intl.formatMessage(messages.productStatus),
        opts.productStatus.value,
        true,
        [
          {
            label: intl.formatMessage(messages.draft),
            value: ProductDetailStatus.DRAFT
          },
          {
            label: intl.formatMessage(messages.ready),
            value: ProductDetailStatus.READY
          },
          {
            label: intl.formatMessage(messages.unlisted),
            value: ProductDetailStatus.UNLISTED
          }
        ]
      ),
      active: opts.productStatus.active
    },
    {
      ...createDateField(
        ProductDetailsBiFilterKeys.updateDate,
        intl.formatMessage(messages.updateDate),
        opts.updateDate.value
      ),
      active: opts.updateDate.active
    }
  ];
}
